import { Component } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';

import { TranslatePipe } from '@next/core-lib/i18n';

import { SettingsNavigationComponent } from '../settings-navigation/settings-navigation.component';

@Component({
  selector: 'app-settings-overview',
  templateUrl: 'settings-overview.component.html',
  imports: [MatToolbar, SettingsNavigationComponent, RouterOutlet, TranslatePipe],
})
export class SettingsOverviewComponent {
  getState = (outlet: RouterOutlet) => outlet.isActivated && outlet.activatedRoute.routeConfig.data;

  constructor() {}
}
